import RequestNewOrdersButton from './RequestNewOrdersButton';

export default RequestNewOrdersButton;
